<template>
  <span>
    <div class="text-right">
      <v-btn
        @click="openCreateDialog"
        color="green"
        dark
        text="right"
        >Tạo phiếu thay đồng hồ</v-btn
      >
    </div>
    <v-flex xs12>
      <v-card>
        <v-data-table
          :loading="loader"
          disable-initial-sort
          :headers="headers"
          :search="search"
          :items="items"
          item-key="_id"
          :rows-per-page-items="rowPerPage"
        >
          <template #items="props">
            <tr>
              <td class="text-no-wrap">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon small color="#464D69">settings</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      @click="
                        selected_meter_change = props.item;
                        trigger_edit_component = !trigger_edit_component;
                      "
                    >
                      <v-list-tile-action>
                        <v-icon small class="zmdi zmdi-edit"></v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>
                        Chỉnh sửa
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="deleteMeterChange(props.item._id)">
                      <v-list-tile-action>
                        <v-icon small class="zmdi zmdi-delete"></v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>
                        Xóa
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
              <td class="text-no-wrap">{{ props.item.receipt_id }}</td>
              <td class="text-no-wrap">
                {{ BUILDING_DISPLAY_MAPPING[props.item.building] }}
              </td>
              <td class="text-no-wrap">{{ props.item.room_id }}</td>
              <td>{{ props.item.change_date | formatTimeServer }}</td>
              <td>{{ props.item.old_meter_number }}</td>
              <td>{{ props.item.new_meter_number }}</td>
              <td>{{ props.item.note }}</td>
            </tr>
          </template>
          <template #no-data>
            Chưa có thông tin
          </template>
        </v-data-table>
      </v-card>
      <dialog-edit-thay-dong-ho-dien-nuoc
        :meter_change="selected_meter_change"
        :dialog="trigger_edit_component"
        @changeDialogState="trigger_edit_component = $event"
        @getData="getData()"
      />
      <dialog-thay-dong-ho-dien-nuoc
        :meter_change="selected_meter_change"
        :dialog="trigger_create_component"
        @changeDialogState="trigger_create_component = $event"
        @getData="getData()"
      />
    </v-flex>
  </span>
</template>

<script>
import { buildParamQuery, formatTimeServer, dayDiff, deepCopy } from "Helpers";
import {
  CONSUMERS_BY_CONSUMER_TYPE,
  BUILDING_DISPLAY_MAPPING,
} from "Constants/db-config";
import api from "Api";
import DialogThayDongHoDienNuoc from "./DialogThayDongHoDienNuoc";
import DialogEditThayDongHoDienNuoc from "./DialogEditThayDongHoDienNuoc";

export default {
  name: "table-thay-dong-ho-dien-nuoc",
  props: {
    type: String,
    date_start: String,
    date_end: String,
    search: String,
  },
  components: {
    DialogThayDongHoDienNuoc,
    DialogEditThayDongHoDienNuoc,
  },
  data() {
    return {
      headers: [
        { text: "Thao tác", align: "left", sortable: true, value: "_id" },
        {
          text: "Mã phiếu",
          align: "left",
          sortable: true,
          value: "receipt_id",
        },
        { text: "Tòa nhà", align: "left", sortable: true, value: "building" },
        { text: "Phòng", align: "left", sortable: true, value: "room_id" },
        {
          text: "Ngày thay",
          align: "left",
          sortable: true,
          value: "change_date",
        },
        {
          text: "Số Đồng Hồ Cũ",
          align: "left",
          sortable: true,
          value: "old_meter_number",
        },
        {
          text: "Số Đồng Hồ Mới",
          align: "left",
          sortable: true,
          value: "new_meter_number",
        },
        { text: "Ghi Chú", align: "center", sortable: true, value: "note" },
      ],
      items: [],
      loader: false,
      rowPerPage: [50, 100, 200, { text: "Tất cả", value: -1 }],
      selected_meter_change: {},
      trigger_edit_component: false,
      trigger_create_component: false,
      BUILDING_DISPLAY_MAPPING,
    };
  },
  watch: {
    date_start: {
      handler: function(nv) {
        this.getData();
      },
      immediate: true,
    },
    date_end: {
      handler: function(nv) {
        this.getData();
      },
      immediate: true,
    },
    type() {
      this.getData();
    },
  },
  created() {},
  methods: {
    async getData() {
      this.items = [];
      const params = {
        date_start: this.date_start,
        date_end: this.date_end,
        type: this.type,
      };

      const query = buildParamQuery(params);
      this.loader = true;
      const data = await api.getListMeterChange(query);
      this.loader = false;
      this.items = data.data;
    },
    openCreateDialog() {
      this.selected_meter_change = {
        type: this.type,
      };
      this.trigger_create_component = !this.trigger_create_component;
    },
    async deleteMeterChange(id) {
      const result = await swal.fire({
        title: "Bạn có chắc chắn muốn xóa phiếu thay đồng hồ này không?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Xóa",
        cancelButtonText: "Hủy",
      });
      if (result.value) {
        await api.deleteMeterChange(id);
        this.getData();
      }
    },
  },
};
</script>
